import styles from "./chatbot.module.scss";

function Chatbot() {
  return (
    <div className={styles.chatbot}>

      {/* SIDEBAR */}
      <aside className={styles.sidebar}>
        <button className={styles.newChat}>
          + Nova Conversa
        </button>

        <div className={styles.history}>
          <h3>Suas Conversas</h3>

          <ul>
            <li>Lugares para visitar</li>
            <li>Hotéis em Aracaju</li>
            <li>Praias de Sergipe</li>
          </ul>
        </div>

        <div className={styles.settings}>
          Configurações
        </div>
      </aside>

      {/* ÁREA PRINCIPAL */}
      <main className={styles.chatArea}>

        {/* HEADER */}
        <div className={styles.chatHeader}>
          <div className={styles.avatar}></div>

          <div>
            <h2>Sergi - Seu Guia Virtual</h2>
            <span>Online</span>
          </div>
        </div>

        {/* MENSAGENS */}
        <div className={styles.messages}>

          {/* mensagem bot */}
          <div className={styles.botMessage}>
            <p>
              Olá! Bem-vindo ao Sergipanidade.
              Como posso tornar sua viagem inesquecível?
            </p>
          </div>

          {/* mensagem usuário */}
          <div className={styles.userMessage}>
            <p>
              Onde encontro o melhor caranguejo?
            </p>
          </div>

          {/* mensagem bot */}
          <div className={styles.botMessage}>
            <p>
              Para uma experiência autêntica,
              recomendo a Passarela do Caranguejo!
            </p>
          </div>

          {/* cards */}
          <div className={styles.cards}>

            <div className={styles.card}>
              <img
                src="https://images.unsplash.com/photo-1566073771259-6a8506099945"
                alt="hotel"
              />

              <h4>Vidam Hotel</h4>

              <button>Ver detalhes</button>
            </div>

            <div className={styles.card}>
              <img
                src="https://images.unsplash.com/photo-1551882547-ff40c63fe5fa"
                alt="hotel"
              />

              <h4>Aquários Praia Hotel</h4>

              <button>Ver detalhes</button>
            </div>

          </div>
        </div>

        {/* INPUT */}
        <div className={styles.inputArea}>
          <input
            type="text"
            placeholder="Pergunte ao Sergi..."
          />

          <button>➤</button>
        </div>

      </main>
    </div>
  );
}

export default Chatbot;